module.exports = __webpack_public_path__ + "static/media/maintenance-bg.c53e4774.jpg";